export default __webpack_public_path__ + "static/media/art_infographic.58806192.png";